var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconVessel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.265,
    height: 57.341,
    viewBox: "0 0 59.265 57.341",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "K\\xE4rl",
    transform: "translate(0.95 0.95)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3906",
    "data-name": "Rectangle 3906",
    width: 56.89,
    height: 4.809,
    rx: 1.108,
    transform: "translate(0 3.098)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24296",
    "data-name": "Path 24296",
    d: "M326.421,1185.8l1.089-2.344a1.275,1.275,0,0,1,1.163-.757h48.905a1.275,1.275,0,0,1,1.163.757l1.09,2.344",
    transform: "translate(-324.681 -1182.701)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24297",
    "data-name": "Path 24297",
    d: "M326.541,1190.046l1.828,36.129h49.514l1.828-36.129",
    transform: "translate(-324.672 -1182.145)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24298",
    "data-name": "Path 24298",
    d: "M333.317,1225.485a4.719,4.719,0,1,1-2.9.9",
    transform: "translate(-324.525 -1179.459)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24299",
    "data-name": "Path 24299",
    d: "M374.1,1225.485a4.716,4.716,0,1,1-2.862.96",
    transform: "translate(-321.426 -1179.459)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24300",
    "data-name": "Path 24300",
    d: "M328.232,1223.626l5.1,6.7v-6.581",
    transform: "translate(-324.544 -1179.6)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24301",
    "data-name": "Path 24301",
    d: "M369.023,1223.626l5.1,6.7v-6.581",
    transform: "translate(-321.453 -1179.6)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4706",
    "data-name": "Group 4706",
    transform: "translate(17.8 12.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24302",
    "data-name": "Path 24302",
    d: "M353.2,1197.292a9.441,9.441,0,0,1,4.827,13.612",
    transform: "translate(-340.452 -1194.193)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24303",
    "data-name": "Path 24303",
    d: "M341.5,1207.853a9.444,9.444,0,0,1,9.286-11.118c.256,0,.509.011.759.03",
    transform: "translate(-341.35 -1194.235)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24304",
    "data-name": "Path 24304",
    d: "M357.038,1212.2a9.441,9.441,0,0,1-14.7-2.641",
    transform: "translate(-341.275 -1193.264)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24305",
    "data-name": "Path 24305",
    d: "M342.034,1213.627l-.046-4.375,4.293.492",
    transform: "translate(-341.302 -1193.287)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24306",
    "data-name": "Path 24306",
    d: "M347.624,1194.411l3.605,2.479-2.872,3.229",
    transform: "translate(-340.875 -1194.411)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24307",
    "data-name": "Path 24307",
    d: "M361.527,1208.184l-3.76,2.237-1.731-3.96",
    transform: "translate(-340.237 -1193.499)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVessel);
export default __webpack_public_path__ + "static/media/Icon_vessel.b6c94daa20b7e60b6a4c6e671f5ae7e3.svg";
export { ForwardRef as ReactComponent };